







































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListDevices } from '@/components/config'

// services
import { DeviceService } from '@/services/config'
import ZKLibService from '@/services/zklib/zklibService'

// utils
import { loading, alerts } from '@/utils'

// models
import { DeviceForm, DeviceModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditDevice from './modalCreateEdit.vue'

const newItem: DeviceForm = {
  name: '',
  ip: '',
  port: '4370',
  observation: '',
  is_active: true,
  amount_max_users: 1000,
  amount_max_attendance: 10000
}

@Component({
  name: 'DevicesIndex',
  components: {
    PageHeader,
    TableListDevices,
    ModalCreateEditDevice
  }
})
export default class DevicesIndex extends Vue {
  showModal = false
  device: DeviceForm = newItem
  title = 'Dispositivos'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Dispositivos',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.device = newItem
    this.showModal = true
  }

  editItem (item: DeviceModel) {
    this.device = {
      name: item.name,
      ip: item.ip,
      port: item.port,
      observation: item.observation,
      is_active: item.is_active,
      amount_max_users: item.amount_max_users,
      amount_max_attendance: item.amount_max_attendance
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async testConnection (deviceSelected: DeviceModel) {
    const msg = `Seguro que desea crear conexión con el Dispositivo: ${deviceSelected.name} el dispositivo quedará deshabilitado durante el proceso, desea continuar?`
    const confirm = await alerts.confirm(msg)
    if (confirm && deviceSelected.id) {
      loading('show')
      ZKLibService.connect(deviceSelected.ip, Number(deviceSelected.port)).then(async (res) => {
        if (res.success) {
          await DeviceService.changeStatusConnection(deviceSelected.id, 1)
          const resInfo = await ZKLibService.getInfo(deviceSelected.ip, Number(deviceSelected.port))
          if (resInfo.success) {
            await DeviceService.updateInfo(deviceSelected.id, {
              amount_attendance: resInfo.attendances,
              amount_users: resInfo.users
            })
          }
          alerts.success()
        } else {
          await DeviceService.changeStatusConnection(deviceSelected.id, 1)
          alerts.error(res.msg)
        }
      }).catch(async () => {
        await DeviceService.changeStatusConnection(deviceSelected.id, 0)
        alerts.error('No se pudo establecer la conexión con el dispositivo')
      }).finally(() => {
        loading('hide')
        this.tableList.getDevicesWithPagination()
      })
    }
  }

  async deleteItem (item: DeviceModel) {
    const msg = `Seguro que desea eliminar el Dispositivo: ${item.name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await DeviceService.delete(item.id)
      alerts.success()
      this.tableList.getDevicesWithPagination()
      loading('hide')
    }
  }

  async changeStatus (info: {id: number; status: boolean}) {
    loading('show')
    try {
      await DeviceService.changeStatus(info.id, info.status)
      alerts.success()
      this.tableList.getDevicesWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getDevicesWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getDevicesWithPagination: () => void }
  }

  get itemInit (): DeviceForm {
      return newItem
  }
}
